import React from 'react';
import SingleKeyContainer from './translation_containers/single_key_container';
import MultiKeyContainer from './translation_containers/multi_key_container';
import MultiPropContainer from './translation_containers/multi_prop_container';

/**
 * @attr translationKey -> Mustn't be provided when translationKeys is provided
 * @attr translationKeys -> (Optional) Must be provided when translationKey is not provided
 * @attr targetProperty ->
 * @attr placeholder (Optional) ->
 */
function TranslationContainer(props) {
    return (props.targetProperties ?
        <MultiPropContainer {...props} /> :
        props.translationKeys ?
            <MultiKeyContainer {...props} /> :
            <SingleKeyContainer {...props} />);
}

export default TranslationContainer;